export const employeeTypeTag = 'employeeType:';
